// Utils

// Filter for use in VirtualizedTable Parent Component
export let _filterTable = (e, dataKey, _this) => {
    let { list } = _this.state; // _this = Component this
    if (!list) return;
    let filterValue = e.target.value.toLowerCase();
    if (filterValue === "all" || filterValue === "") {
        _this.setState({ filteredList: list });
        return;
    }
    let updatedFilteredList = list.filter(item => String(item[dataKey]).toLowerCase().includes(filterValue));
    _this.setState({ filteredList: updatedFilteredList });
}

export let _multiFilterTable = (e, dataKeys, _this) => {
    let { list } = _this.state; // _this = Component this
    if (!list) return;
    let filterValue = e.target.value.toLowerCase();
    if (filterValue === "all" || filterValue === "") {
        _this.setState({ filteredList: list });
        return;
    }
    let updatedFilteredList = list.filter(item => dataKeys.some((key) => String(item[key]).toLowerCase().includes(filterValue)));
    _this.setState({ filteredList: updatedFilteredList });
}


// WEBPACK FOOTER //
// ./src/features/common/VirtualizedTable/virtualized-table-util.js